import React, { useEffect, useMemo, useState } from 'react';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import GlobalSelectFieldWithoutFormik from '../../../../components/mui/GlobalSelectFieldWithoutFormik';
import GlobalTable from '../../../../components/CustomTableWithPagination/GlobalTable';
import { COMPANY } from './utils/employeeDetailsPageHelper';
import { useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getSalesDetails } from '../../../../redux/features/dashboardSlice';
import { SalesDetailsTableHeader } from './utils/salesDetailsPageHelper';
import dayjs from 'dayjs';
import { Card, Stack, Typography, Grid } from '@mui/material';
import FromAndToDatePicker from '../../../../components/mui/FromAndToDatePicker';

function SalesRetentionDetails() {
  const dispatch = useDispatch();

  const [searchParams, setSearchParams] = useSearchParams();

  const queryFromDate = searchParams.get('fromDate');
  const queryToDate = searchParams.get('toDate');

  const [filters, setFilters] = useState({
    fromDate: dayjs().startOf('month').format('YYYY-MM-DD'),
    toDate: dayjs().endOf('month').format('YYYY-MM-DD'),
    company: { id: -1, value: '' },
  });

  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    sort: { field: '', direction: '' },
    frozenColumns: [],
    hiddenColumns: [],
  });

  const salesDetailsLoading = useSelector((state) => state.dashboard.salesDetails.loading);
  const salesDetailsData = useSelector((state) => state.dashboard.salesDetails.data);
  const salesDetailsMeta = useSelector((state) => state.dashboard.salesDetails.meta);

  const filterHelper = (value, key) => {
    if (!value || !key) return;
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  useEffect(() => {
    const params = {
      search: tableState?.search,
      startDate: filters.fromDate,
      endDate: filters.toDate,
      page: tableState?.page,
      limit: tableState?.pageSize,
      sortBy: tableState.sort.field,
      sortDirection: tableState.sort.direction,
      dept: filters.company?.id === -1 ? 'all' : filters.company?.id,
    };

    dispatch(getSalesDetails(params));
  }, [filters, tableState.search, tableState.page, tableState.pageSize, dispatch, tableState.sort]);

  useEffect(() => {
    if (queryFromDate) {
      filterHelper(dayjs(queryFromDate).format('YYYY-MM-DD'), 'fromDate');
    }
    if (queryToDate) {
      filterHelper(dayjs(queryToDate).format('YYYY-MM-DD'), 'toDate');
    }
  }, [queryFromDate, queryToDate]);
  return (
    <GlobalWrapper title={'Sales Details'}>
      <Stack direction={{ xs: 'column', sm: 'row' }} gap={1} mb={1}>
        <FromAndToDatePicker
          fromDate={filters.fromDate}
          toDate={filters.toDate}
          setFromDate={(v) => filterHelper(dayjs(v).format('YYYY-MM-DD'), 'fromDate')}
          setToDate={(v) => filterHelper(dayjs(v).format('YYYY-MM-DD'), 'toDate')}
          fullWidth
        />
        <GlobalSelectFieldWithoutFormik
          sx={{ width: { xs: '100%', sm: 200 } }}
          keys={{
            itemId: 'id',
            itemValue: 'name',
          }}
          label={'Company'}
          data={COMPANY}
          setDirectChange={(v) => filterHelper(v, 'company')}
          selectedDetails={filters['company']}
        />
      </Stack>

      <GlobalTable
        rowUniqueId="saleId"
        headers={SalesDetailsTableHeader}
        rows={salesDetailsData}
        loading={salesDetailsLoading}
        tableState={tableState}
        setTableState={setTableState}
        meta={salesDetailsMeta}
      />
    </GlobalWrapper>
  );
}

export default SalesRetentionDetails;
